<!-- =========================================================================================
  File Name: Orders.vue
  Description: Orders' list
  ----------------------------------------------------------------------------------------
  Item Name: FastWay - Stock transactions' list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>

  <div>
    <div class="vx-card p-6">
      <ejs-grid
        ref="grid"
        :dataSource="data"
        locale='es-GT'
        :toolbar='toolbarOptions'
        :allowPaging="true"
        :pageSettings='pageSettings'
        :allowSorting='true'
        :sortSettings='sortOptions'
        :allowExcelExport='true'
        :toolbarClick='toolbarClick'
        :allowFiltering='true'
        :filterSettings='filterOptions'
        v-if="loaded"
      >
        <e-columns>
          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100" :template="cTemplate" displayValue="id" routeName="order" urlBase="/orders/order"/>
          <e-column field="orderNumber" headerText="Número" width="200" :template="cTemplate" displayValue="orderNumber" routeName="order" urlBase="/orders/order"/>
          <e-column field="date" headerText="Fecha" width="180" :valueAccessor="formatDate"/>
          <e-column field="userName" headerText="Cliente" :filter='checkBoxFilter'/>
          <e-column field="user" headerText="Usuario" width="300" :filter='checkBoxFilter'/>
          <e-column field="orderTotal" type="number" headerText="Valor" textAlign='Right' format="N2" width="130"/>
          <e-column field="status" headerText="Estado" width="150" :filter='checkBoxFilter'/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Filter} from '@syncfusion/ej2-vue-grids';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import CellRendererLink from '@/views/components/CRLinkS';
  import {db} from '@/firebaseConfig';

  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'grid': {
        'EmptyRecord': 'No se encontraron órdenes',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        pageSettings: {pageSize: 15},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'date', direction: 'Descending'}, {field: 'id', direction: 'Descending'}]},
        statusId: null,
        loaded: false,
        data: [],
        cTemplate: function () {
          return {template: CellRendererLink, urlBase: '/orders/order'};
        },
        filterOptions: {
          type: 'Menu'
        },
        checkBoxFilter: {
          type: 'CheckBox'
        }
      }
    },
    components: {
      CellRendererLink
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport, Filter]
    },
    methods: {
      formatDate: function (field, data) {
        let ret = '';
        if (data[field]) {
          const d = data[field].toDate();
          ret = `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
        }
        return ret;
      },
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          const excelExportProperties = {
            fileName: "ListadoÓrdenesTiendaEnLinea.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
          // this.statistic();
        }
      },
      statistic() {
        const data = [];
        let date = null;
        let j = 0;
        for (let i = 0; i < this.data.length; i++) {
          date = this.data[i].date.toDate();
          if (date.getFullYear() == 2021) {
            for (j = 0; j < this.data[i].products.length; j++) {
              data.push({
                date: `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`,
                productId: this.data[i].products[j].productId,
                isbn: this.data[i].products[j].isbn,
                description: this.data[i].products[j].description,
                price: this.data[i].products[j].price,
                quantity: this.data[i].products[j].quantity,
                amount: this.data[i].products[j].amount,
                couponCode: this.data[i].couponCode,
                couponName: this.data[i].couponName
              });
            }
          }
        }
        console.log(data);
      },
      getList() {
        this.$vs.loading({
          text: 'Cargando listado de órdenes',
          type: 'point'
        });
        const self = this;
        db.collection('orders')
          .get()
          .then(querySnapshot => {
            self.data = querySnapshot.docs.map(doc => doc.data());
            self.loaded = true;
            self.$vs.loading.close();
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al cargar listado de órdenes',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          });
      },
      edit(id) {
        this.$router.push(`//order/${id}`).catch(() => {
        });
      }
    },
    mounted() {
      this.getList();
    }
  }

</script>

<style lang="scss">
  @import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
  @import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';

  .add-button {
    position: fixed;
    bottom: 5%;
    right: 29px;
    z-index: 51000;
    box-shadow: 0 1px 20px 1px rgb(251, 67, 79);
  }
</style>
